import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core';
import { BaseViewComponent, Enum, Field, GetAnimationDuration, Scope, TabKind } from '@sb/library/base';
import { TabComponent } from '../../tab.component';

export class TabGroupBodyScope extends Scope {
    RefreshTab = Field<(selectedTab: any) => void>();
}

@Component({
    selector: 'lib-tab-group-body',
    templateUrl: './tab-group-body.component.html',
    styleUrls: ['./tab-group-body.component.scss']
})
export class TabGroupBodyComponent<T extends Enum<string>> extends BaseViewComponent implements TabGroupBodyScope, OnInit {
    Scope = this.SetScope({
        Implements: TabGroupBodyScope
    });

    @ContentChildren(TabComponent, {descendants: true}) tabComponentQueryList!: QueryList<TabComponent<T>>;

    @Input() kind: TabKind = TabKind.Default;
    @Input() lazyLoading: boolean = true;
    @Input()
    set overrideSelectedIndex(value: number) {
        if (value >= 0) {
            this.selectedIndex = value;
        }
    }

    @Output() animationDone: EventEmitter<void> = new EventEmitter();

    get animationDuration(): string {
        return `${GetAnimationDuration(this.isMobile || this.isTablet)}ms`;
    }

    private _isAnimationComplete: boolean = true;
    private _selectedIndex: number | null = null;

    RefreshTab(selectedTab: T): void {
        const tabToRefresh = this.tabComponentQueryList.find(tab => tab.name == selectedTab);
        if (tabToRefresh) {
            const lazyLoadState = tabToRefresh.lazyLoad;
            tabToRefresh.lazyLoad = !lazyLoadState;
            setTimeout(() => {
                tabToRefresh.lazyLoad = lazyLoadState;
            });
        }
    }

    AnimationDone(): void {
        this._isAnimationComplete = true;
        this.animationDone.emit();
    }

    TrackTab(tab: TabComponent<T>, index: number): string | number{
        return tab.name ?? index;
    }

    get selectedIndex(): number | null {
        return this._selectedIndex;
    }

    get isAnimationComplete(): boolean {
        return this._isAnimationComplete;
    }

    set selectedIndex(value: number | null) {
        if (this._selectedIndex !== null && value !== this._selectedIndex) {
            this._isAnimationComplete = false;
        }
        this._selectedIndex = value;
    }
}
